import { INPUT_TYPE } from "deskera-ui-library";
import { COLUMN_CODE, TableManger, TABLES } from "./TableManger";
import { CONSTANTS, workWeek, FORMAT } from "../constants/Constant";
import moment from "moment"
import { TENANT, TenantService } from "./TenantManagerService";
import Utility from "../utility/Utility";
import { reverseTimezoneOffset } from "./common/CommonUtil";

export class PayrollManager {

    static otIds = [];
    static rhIds = [];
    static lopIds = [];

    static getDefaultValues(values = {}) {
        return {
            // [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_SCHEDULE)] : [0],
            [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_PERIOD)]: [0],
            [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.WORK_WEEKS)]: PayrollManager.getWorkingDays(),
            [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_DAY)]: [0],
            [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.LOCATION)]: [0],
            [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.APPLICABLE_TO_ALL)]: [1],
            [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_DATE)]: moment().endOf('month').toDate(),
            ...values
        }
    }
    static getWorkingDays() {
      let workWeekIds = [];
      let tenantWorkWeek = TenantService.get(TENANT.TENANT_WORK_WEEK)
      tenantWorkWeek.forEach(ele=>{
        if(ele.isWorkingDay) {
          let ind = workWeek.findIndex(w=> w.name.toLowerCase()==ele.day.toLowerCase())
          if(ind != -1) {
            workWeekIds.push(parseInt(workWeek[ind].id))
          }
        }
      })
      return workWeekIds
    }

    static getDataToUpdateForPayroll = (data, columns) => {
        let contactColumns = {};
        columns.forEach(column => {
            if (column.type === INPUT_TYPE.SELECT || column.type === INPUT_TYPE.MULTI_SELECT) {
                contactColumns[column.id] = column;
            }
        });
        Object.keys(contactColumns).forEach(item => {
            if (data[item]) {
                data[item] = data[item].map(r => contactColumns[item].options.findIndex(op => op.id === r));
            }
        })
    }

    static parseUserList = (dataSource) => {
        let data = [];
        if(dataSource && dataSource.length > 0) {
            dataSource.forEach(element => {
                let group = {
                    id: element['userId'],
                    name: `${element['firstName']} ${element['lastName']}`
                }
                data.push(group);
            });
        }
        return data;
    }

    static parseLocationList = (dataSource) => {
      let data = [];
      if(dataSource && dataSource.length > 0) {
          dataSource.forEach(element => {
              let group = {
                  id: element['id'],
                  name: element['name']
              }
              data.push(group);
          });
      }
      data.splice(0, 0, {"id":"", name : "None"})
      return data;
  }

    static getDataToUpdateForPayrollEmployees = (data, columns) => {
        let contactColumns = {};
        columns.forEach(column => {
            if (column.type === INPUT_TYPE.SELECT || column.type === INPUT_TYPE.MULTI_SELECT) {
                contactColumns[column.id] = column;
            }
        });
        Object.keys(contactColumns).forEach(item => {
            if (data[item]) {
                data[item] = data[item].map(r => contactColumns[item].options.findIndex(op => op.id === r));
            }
        })
    }

    static getPayrollDefaultValues(values = {}, customFields) {
        let group = {
          [TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.PAY_SCHEDULE
          )]: [values.paySchedule.id],
          [TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.PAY_PERIOD
          )]: [values.payPeriod],
          [TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.WORK_WEEKS
          )]: values.workWeek,
          [TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.PAY_DAY
          )]: [values.payDay],
          [TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.PAY_DATE
          )]: values.payDate
            ? moment(values.payDate, "MM/DD/YYYY").toDate()
            : moment().endOf('month').toDate(),
          [TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.WORK_PERIOD_FROM
          )]:
            values.workPeriod && values.workPeriod.from
              ? moment(values.workPeriod.from, "MM/DD/YYYY").toDate()
              : "",
          [TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.WORK_PERIOD_To
          )]:
            values.workPeriod && values.workPeriod.to
              ? moment(values.workPeriod.to, "MM/DD/YYYY").toDate()
              : "",
          [TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.APPLICABLE_TO_ALL
          )]: values.isForAllUsers ? ["YES"] : ["NO"],
          [TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.LOCATION
          )]: [values.location],
          [TableManger.getColumnId(
            TABLES.ADD_PAYROLL,
            COLUMN_CODE.ADD_PAYROLL.USERS
          )]: values.employees || [],
          // ...values
        };
        group = PayrollManager.updateCustomFieldValues(values, customFields, group)

        return group;
    }

    static updateCustomFieldValues(values, customFieldsData, group) {
        const { customFields } = customFieldsData || [];
        const customFieldFormValues = values?.customFields || [];
        customFields?.forEach((c) => {
            const formValues = customFieldFormValues.find((x) => x.fieldId === c.id);
            if(!Utility.isEmptyObject(formValues)) {
                switch (c.type) {
                    case "text":
                        if(formValues?.fieldValue) {
                            group[c.id] = formValues?.fieldValue[0];
                        }
                        break;
                    case "multiselect":
                        group[c.id] = formValues?.fieldValue;
                        break;
                    case "date":
                        const date = moment(Utility.formatDate(formValues?.fieldValue?formValues.fieldValue[0]:"")).toDate();
                        group[c.id] = Utility.isValidDate(date) ? reverseTimezoneOffset(date) : "";
                        break;
                    default:
                        if(formValues?.fieldValue) {
                            group[c.id] = formValues?.fieldValue[0];
                        }
                        break;
                }
            }
        });
        return group;
    }

    static getAddPayrunDefaultValues(customFieldsData, values = {}) {
        let group = {
            [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_PERIOD)]: [0],
            [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.WORK_WEEKS)]: PayrollManager.getWorkingDays(),
            [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_DAY)]: [0],
            [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.LOCATION)]: [0],
            [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.APPLICABLE_TO_ALL)]: [1],
            [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_DATE)]: moment().endOf('month').toDate(),
            [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.USERS)]:[],
            ...values
        }
        group = PayrollManager.updatePayrunWithCustomFieldDefaultValues(customFieldsData, group);
        return group;
    }

    static updatePayrunWithCustomFieldDefaultValues(customFieldsData, group) {
        const { customFields } = customFieldsData;
        customFields.forEach((c) => {
                switch (c.type) {
                    case "text":
                        if(c?.defaultValue) {
                            group[c.id] = c?.defaultValue[0];
                        }
                        break;
                    case "multiselect":
                        const defaultValue = [];
                        c?.defaultValue.forEach((d) => {
                            let index = c.possibleValues.findIndex((p) => p === d);
                            if(index != -1) {
                                defaultValue.push(index);
                            }
                        })

                        group[c.id] = defaultValue;
                        break;
                
                    default:
                        group[c.id] = c?.defaultValue[0];
                        break;
                }
        });
        return group;
    }

    static parseLocationListData = (dataSource) => {
        let data = [];
        if(dataSource && dataSource.length > 0) {
            dataSource.forEach(element => {
                let group = {
                    id: element['id'],
                    name: element['label']
                }
                data.push(group);
            });
        }
        data.splice(0, 0, {"id":"", name : "None"})
        return data;
    }

}